<template>
  <div class="answer-detail">
    <audio
      v-if="currentAudio.src"
      class="survey-audio"
      controls
      autoplay
      :src="currentAudio.src"
    >
    </audio>
    <div class="answer-title">{{title}}</div>
    <div class="survey-audios">
      <audio-item
        v-for="(audio,index) in audios"
        :key="index"
        :audio="audio"
        :index="index"
        :current-index="currentAudio.index"
        @play="playAudio"
      ></audio-item>
    </div>
    <div class="answer-info">
      <div class="start_time">开始答题：{{answerData.started_at}}</div>
      <div class="time">答题时长：{{answerData.time}}</div>
      <div class="ip">IP：{{answerData.ip||'-'}}</div>
      <el-tooltip
        :disabled="show"
        :content="answerData.ua"
        placement="top"
        :hide-after="2000"
      >
        <div
          class="browser"
          @mouseover="mouseover"
        >浏览器：{{answerData.ua||'-'}}</div>
      </el-tooltip>
    </div>
    <component
      :is="'a'+item.type"
      v-for="(item,index) in questions"
      :key="index"
      :data="item"
      :index="++index"
    >
    </component>
    <preview-video></preview-video>
    <preview-image></preview-image>
  </div>
</template>

<script>
import { getAnswerDetail } from "@/api/stat";
import Acheckbox from "./components/a-checkbox";
import Aradio from "./components/a-radio";
import Aselect from "./components/a-select";
import Ainput from "./components/a-input";
import AudioItem from "./components/audio-item";
import PreviewVideo from "./components/preview-video";
import PreviewImage from "./components/preview-image";
export default {
  props: {
    aid: {
      type: [String, Number]
    }
  },
  data() {
    return {
      answerData: {},
      show: false,
      currentAudio: {}
    };
  },
  computed: {
    title() {
      let content = this.answerData.content || {};
      return content.title || "";
    },
    questions() {
      let content = this.answerData.content || {};
      let questions = content.questions || [];
      return questions;
    },
    audios() {
      return this.answerData.audios || [];
    }
  },
  mounted() {
    this.getAnswerDetail();
  },
  methods: {
    getAnswerDetail() {
      getAnswerDetail(this.aid).then(res => {
        this.answerData = res.data;
      });
    },
    playAudio(audio) {
      if (audio.index === this.currentAudio.index) {
        this.currentAudio = {};
        return;
      }
      this.currentAudio = audio;
    },
    mouseover(e) {
      this.show = e.target.scrollWidth <= e.target.clientWidth;
    }
  },
  components: {
    Acheckbox,
    Aradio,
    Aselect,
    Ainput,
    AudioItem,
    PreviewVideo,
    PreviewImage
  }
};
</script>

<style lang="less" scoped>
.answer-detail {
  // width: 910px;
  // margin: 0 auto;
  position: relative;
  padding: 50px;
  margin-bottom: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .answer-title {
    text-align: center;
    color: #1d82fc;
    font-size: 24px;
  }

  .answer-info {
    display: flex;
    font-size: 16px;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #333333;

    .browser {
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.survey-audio {
  position: absolute;
  left: 50px;
  top: 10px;
  height: 40px;
}
.answer-item {
  margin-top: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ededed;

  .answer-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .type {
    display: inline-block;
    font-size: 14px;
    color: #1d82fc;
    border: 1px solid #1d82fc;
    padding: 0 12px;
    margin-left: 40px;
  }
}
.preview-dialog {
  .el-dialog__body {
    padding: 30px 0;
  }
}
</style>
